import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link, Redirect } from "react-router-dom";
import Alert from "react-bootstrap/Alert";
import AddQuoteForm from "~/Components/Elements/Forms/AddQuote/AddQuoteForm";
import { useUser } from "@dreamchimney/user-context";

const AddQuotePage = (props) => {
  const { state: userState, dispatch } = useUser();
  const [saved, setSaved] = useState(false);
  const [failure, setFailure] = useState(false);
  const onFailure = () => {
    setFailure(true);
  };
  const onSave = () => {
    setSaved(true);
  };
  if (!userState.loaded) {
    return null;
  }
  const isChim = userState && userState.loggedin && userState.isChim;

  if (!isChim) {
    return (
      <Redirect
        to={{
          pathname: "/",
          state: {},
        }}
      />
    );
  }

  return (
    <div className="quote-add-page">
      {saved && (
        <div className="thank-you font-white">
          <p>
            <strong>Great quote. We just added it.</strong>
          </p>
          <p>
            <Link to={`/`}>Check it out now</Link>
          </p>
        </div>
      )}
      {failure && !saved && <Alert variant="danger">There was an error while saving.</Alert>}

      {!saved && (
        <div>
          <AddQuoteForm onFailure={onFailure} onComplete={onSave} />
        </div>
      )}
    </div>
  );
};

AddQuotePage.propTypes = {
  // bla: PropTypes.string,
};

AddQuotePage.defaultProps = {
  // bla: 'test',
};

export default AddQuotePage;
